export const useNamedRoutes = (route: VNuxtLinkTo): string =>
    useRouter().resolve(route).href
